


















import {Component, Vue, Prop, Model} from 'vue-property-decorator';
import draggable from 'vuedraggable';
import SplitList from '@c/controls/SplitList.vue';
import {Splitpanes, Pane} from 'splitpanes';
import 'splitpanes/dist/splitpanes.css';
import Card from '@c/Card.vue';

@Component({
  components: {
    draggable,
    SplitList,
    Splitpanes,
    Pane,
    Card,
  },
})
export default class DragList extends Vue {
  // Наименование ключевого поля у элементов
  @Prop({required: false, default: 'id'})
  keyFieldName!: string;

  // Модель колонок
  @Prop({required: true})
  columns!: any;

  // Модель элементов
  @Model('change') _changedItemsMap!: any;

  get changedItemsMap() {
    return this._changedItemsMap;
  }

  set changedItemsMap(changedItemsMap: any) {
    this.$emit('change', changedItemsMap);
  }

  // Действия при удалении элемента из списка
  onRemove(item: any) {
    for (const key in this.changedItemsMap) {
      this.changedItemsMap[key] = this.changedItemsMap[key].filter((e: any) => e.id !== item.id);
    }
  }

  // Получить ключ элемента
  getKey(item: any) {
    return item[this.keyFieldName];
  }
}
